import CompraFormaPagamento from './CompraFormaPagamento';

export default CompraFormaPagamento;
